import React from 'react';

const logos = [
  { src: '/BDL.jfif', alt: 'Tennis Club Bois du Loup', url: 'https://www.boisduloup.be/' },
  { src: '/JUMET.jfif', alt: 'RETC Jumet', url: 'https://www.facebook.com/RETCJUMET' },
  { src: '/333.jfif', alt: '333 Padel', url: 'https://www.facebook.com/p/333-Padel-61556247308483/' },
  { src: '/adeps.jfif', alt: 'Adeps Le Mosane', url: 'https://www.facebook.com/Centre.sportif.Adeps.La.Mosane/?locale=fr_FR' },
  { src: '/grez.jfif', alt: 'Grez-Doiceau', url: 'https://www.facebook.com/p/Hall-Omnisports-de-Grez-Doiceau-100063821912059/' },
  { src: '/padelone.jfif', alt: 'Padel One', url: 'http://www.padel-one.be/' },
  { src: '/toro.jfif', alt: 'Padel Toro', url: 'http://www.padeltoro.com/' },
  { src: '/h5.jfif', alt: 'High 5 Padel', url: 'https://www.high5padel.com/' },
  { src: '/zenith.jfif', alt: 'Zenith Padel Club', url: 'https://www..com/' },
  { src: '/ressaix.jfif', alt: 'Ressaix Papillon', url: 'https://www..com/' },
  { src: '/hockey.jfif', alt: 'Hockey', url: 'https://www..com/' },
];

const repeatCount = 3;

const ScrollingLogosBar = () => {
  const repeatedLogos = [];
  for(let i=0; i<repeatCount; i++) {
    repeatedLogos.push(...logos);
  }

  return (
    <>
      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.3333%);
          }
        }
        .scrolling-logos-container {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100vw;
          height: 2rem; /* Très fin */
          background: rgba(255 255 255 / 0.9);
          border-top: 1px solid #4c2f8e;
          overflow: hidden;
          display: flex;
          align-items: center;
          backdrop-filter: saturate(180%) blur(6px);
          box-shadow: 0 0 6px rgb(76 47 142 / 0.15);
          z-index: 50;
          padding: 0 0.5rem;
        }
        .scrolling-logos-inner {
          display: flex;
          width: calc(100% * ${repeatCount});
          animation: scroll 25s linear infinite;
        }
        .scrolling-logos-inner a {
          flex-shrink: 0;
          display: inline-block;
          margin: 0 0.5rem;
        }
        .scrolling-logos-inner img {
          height: 1.5rem;
          width: 1.5rem;
          object-fit: contain;
          border-radius: 9999px;
          opacity: 0.75;
          transition: opacity 0.3s;
        }
        .scrolling-logos-inner img:hover {
          opacity: 1;
        }

        /* Mobile et PC identiques, très fin partout */
        @media (max-width: 640px) {
          .scrolling-logos-container {
            height: 2rem;
            padding: 0 0.3rem;
          }
          .scrolling-logos-inner {
            animation-duration: 20s;
          }
          .scrolling-logos-inner a {
            margin: 0 0.3rem;
          }
          .scrolling-logos-inner img {
            height: 1.3rem;
            width: 1.3rem;
            opacity: 0.8;
          }
        }
      `}</style>

      <div className="scrolling-logos-container" aria-label="Partenaires et clubs">
        <div className="scrolling-logos-inner">
          {repeatedLogos.map(({ src, alt, url }, index) => (
            <a
              key={`logo-${index}`}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={alt}
            >
              <img src={src} alt={alt} loading="lazy" />
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default ScrollingLogosBar;
